module.exports = __webpack_public_path__ + "img/proprietor.21d392cb.jpg";